import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../utils/cn";

const iconBadgeVariants = cva("inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium", {
    variants: {
        variant: {
            default: "bg-muted text-muted-foreground",
            secondary: "bg-secondary/10 text-secondary",
            success: "bg-success/10 text-success",
            destructive: "bg-destructive/10 text-destructive",
            warning: "bg-warning/10 text-warning",
            primary: "bg-primary/10 text-primary",
            pink: "bg-pink-50 text-pink-600",
            violet: "bg-violet-50 text-violet-600",
            sky: "bg-sky-50 text-sky-600",
            amber: "bg-amber-50 text-amber-600",
            teal: "bg-teal-50 text-teal-600",
            indigo: "bg-indigo-50 text-indigo-600",
            VIDEO: "text-pink-400 bg-pink-400/10",
            TEXT: "text-amber-600 bg-amber-600/10",
            QUIZ: "text-indigo-600 bg-indigo-600/10",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export interface IconBadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof iconBadgeVariants> {
    icon?: React.ReactNode;
}

const IconBadge = React.forwardRef<HTMLSpanElement, IconBadgeProps>(
    ({ className, variant, icon, children, ...props }, ref) => (
        <span ref={ref} className={cn(iconBadgeVariants({ variant }), className)} {...props}>
            {icon && <span className="shrink-0 [&>svg]:h-3 [&>svg]:w-3">{icon}</span>}
            {children}
        </span>
    ),
);
IconBadge.displayName = "IconBadge";

export { IconBadge, iconBadgeVariants };
